<template>
  <div class="page-not-found page-not-found is-flex is-align-items-center">
    <div class="container">
      <div class="pic-404">
        <span>4</span>
        <HomeIcon />
        <HomeIcon />
        <span>4</span>
      </div>
      <h1 class="is-hidden">404</h1>
      <h2>Your tour does not exist <br />or was deleted.</h2>
    </div>
  </div>
</template>

<script>
  import HomeIcon from '@/assets/svg/home.svg';

  export default {
    components: {
      HomeIcon
    }
  };
</script>

<style lang="scss">
  @charset "utf-8";

  @import url("https://fonts.googleapis.com/css?family=Fira+Sans:400,700&subset=latin-ext");

  @import "../assets/styles/mixins";

  $family-sans-serif: 'Fira Sans', sans-serif;
  $body-color: #484848;
  $body-background-color: #fff;

  $xs: 520px;

  @import "~bulma/sass/utilities/_all.sass";
  @import "~bulma/sass/base/_all.sass";
  @import "~bulma/sass/elements/container.sass";

  .page-not-found {
    display: flex;
    align-items: center;
    min-height: 100vh;
    padding-top: 50px;
    padding-bottom: 50px;
    text-align: center;

    .pic-404 {
      position: relative;
      margin: 0 auto 20px;
      width: 90px;

      @include min-screen($xs) {
        width: 140px;
      }

      svg:nth-child(3) {
        transform: rotate(180deg);

        path {
          fill: #f5f5f5;
        }
      }

      span {
        position: absolute;
        top: -30px;
        font-size: 150px;
        font-weight: 700;

        @include min-screen($xs) {
          top: -45px;
          font-size: 230px;
        }

        &:first-child {
          left: -98px;

          @include min-screen($xs) {
            left: -150px;
          }
        }

        &:last-child {
          right: -98px;

          @include min-screen($xs) {
            right: -150px;
          }
        }
      }
    }

    h2 {
      font-size: 24px;
      line-height: 1.25;

      @include min-screen($xs) {
        font-size: 32px;
      }
    }
  }
</style>
